import { Action, createReducer, on } from '@ngrx/store';
import cloneDeep from 'lodash.clonedeep';

import { NotaryRequest } from '@core/models/notary-request.model';

import * as NotaryRequestActions from './notary-request-actions';

export type NotaryRequestState = NotaryRequest | null;
export const initialState: NotaryRequestState = null;

const notaryRequestReducer = createReducer(
  initialState,
  // on(NotaryRequestActions.selectAll, setNotaryRequest),
  on(NotaryRequestActions.select, setNotaryRequest),
  on(NotaryRequestActions.update, setNotaryRequest),
  on(NotaryRequestActions.patch, (state, { notaryRequestPartial }) => ({
    ...state,
    ...notaryRequestPartial
  })),
  on(NotaryRequestActions.remove, () => initialState)
);

function setNotaryRequest(_, { notaryRequest }: { notaryRequest: NotaryRequest }): NotaryRequestState {
  return cloneDeep(notaryRequest);
}

export function reducer(state: NotaryRequestState, action: Action): NotaryRequestState {
  return notaryRequestReducer(state, action);
}
